// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AddressType } from './address-type';
import { AdminAddress } from './admin-address';
import { BankruptAddress } from './bankrupt-address';
import { ContactAddress } from './contact-address';
import { CounterpartyAddress } from './counterparty-address';
import { Creditor } from './creditor';
import { Employee } from './employee';
import { PracticeAddress } from './practice-address';
import { Shareholder } from './shareholder';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Address extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  addressId!: number;
  address1?: string;
  addressTypeId!: number;
  city?: string;
  country?: string;
  createdBy!: string;
  createdDate!: Date;
  isMailing!: boolean;
  postCode?: string;
  state?: string;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  addressType!: AddressType;
  adminAddresses!: AdminAddress[];
  bankruptAddresses!: BankruptAddress[];
  contactAddresses!: ContactAddress[];
  counterpartyAddresses!: CounterpartyAddress[];
  creditors!: Creditor[];
  employees!: Employee[];
  practiceAddresses!: PracticeAddress[];
  shareholders!: Shareholder[];
}

